export function resolveMonitorRecordType(item) {
  if (!item) {
    return "TIMED";
  }
  if (item.recordType) {
    return item.recordType;
  }
  if (item.isAlarm) {
    return "ALARM";
  }
  if (item.routeStatus === 11) {
    return "PHONE";
  }
  if (item.routeStatus) {
    return "SERVICE_NODE";
  }
  if (item.isCapture) {
    return "MANUAL";
  }
  return "TIMED";
}
